import React from 'react';

function ModalFooter({
  firstBtnName,
  secondBtnName,
  thirdBtnName,
  frstDataId,
  secondDataId,
  thirdBtnId,
  isDisabled,
  secondBtnHandler,
  firstBtnHandler,
  firstBtnTooltip,
  secondBtnTooltip,
  thirdBtnHandler
}) {
  return (
    <div className="align-center">
      <button
        id={frstDataId}
        type="button"
        className="btn turquoise mr-2"
        data-id={frstDataId}
        disabled={isDisabled}
        onClick={firstBtnHandler}
        title={firstBtnTooltip || firstBtnName}
      >
        {firstBtnName}
      </button>
      <button
        id={secondDataId}
        type="button"
        title={secondBtnTooltip || secondBtnName}
        className="btn Modal-close close"
        data-id={secondDataId}
        onClick={secondBtnHandler}
      >
        {secondBtnName}
      </button>
      {thirdBtnName ? (
        <button id={thirdBtnId} type="button" className="btn Modal-close close" data-id={thirdBtnId} onClick={thirdBtnHandler}>
          {thirdBtnName}
        </button>
      ) : null}
    </div>
  );
}

export default ModalFooter;
